import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

import type {TermsState} from '../types/terms.types';

const INITIAL_STATE = {
  openCloseModalTerms: false,
  isAccreditationPolicyAccepted: false,
  isReceiptTermAccepted: false,
  isSimulationAccepted: false,
  commercialConditions: [],
  commercialConditionsSelected: []
};

export const useTermsStore = create<TermsState>()(
  devtools(
    (set) => ({
      ...INITIAL_STATE,

      setOpenCloseModalTerms: (flag) =>
        set({openCloseModalTerms: flag}, false, 'terms/setOpenCloseModalTerms'),

      accreditationPolicyAccepted: (flag) =>
        set(
          {isAccreditationPolicyAccepted: flag},
          false,
          'terms/accreditationPolicyAccepted'
        ),

      receiptTermAccepted: (flag) =>
        set({isReceiptTermAccepted: flag}, false, 'terms/receiptTermAccepted'),

      simulationAccepted: (flag) =>
        set({isSimulationAccepted: flag}, false, 'terms/simulationAccepted'),

      commercialConditionsReceived: (conditions) =>
        set(
          {commercialConditions: conditions},
          false,
          'terms/commercialConditionsReceived'
        ),

      setCommercialConditionsSelected: (conditions) =>
        set(
          {commercialConditionsSelected: conditions},
          false,
          'terms/setCommercialConditionsSelected'
        )
    }),
    {name: 'TermsStore'}
  )
);

export const selectOpenCloseModalTerms = (state: TermsState) =>
  state.openCloseModalTerms;
export const selectIsAccreditationPolicyAccepted = (state: TermsState) =>
  state.isAccreditationPolicyAccepted;
export const selectIsReceiptTermAccepted = (state: TermsState) =>
  state.isReceiptTermAccepted;
export const selectIsSimulationAccepted = (state: TermsState) =>
  state.isSimulationAccepted;
export const selectCommercialConditions = (state: TermsState) =>
  state.commercialConditions;
export const selectCommercialConditionsSelected = (state: TermsState) =>
  state.commercialConditionsSelected;
